module.exports = __webpack_public_path__ + "img/docx.98d7dd18.svg";